import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class ScrollTabsController extends Controller {
  static targets = [
    'panel',
    'link'
  ];

  initialize() {
    this.visiblePanelIds = new Set();
    this.observer = new IntersectionObserver(
      this.#updateActiveTab.bind(this),
      {
        root: null,
        threshold: 0.3
      }
    );
  }

  connect() {
    this.panelTargets.forEach(panel => this.observer.observe(panel));
  }

  disconnect() {
    this.observer.disconnect();
  }

  #updateActiveTab(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.visiblePanelIds.add(entry.target.id);
      } else {
        this.visiblePanelIds.delete(entry.target.id);
      }
    });

    const topmostVisiblePanel = this.panelTargets.find(panel =>
      this.visiblePanelIds.has(panel.id)
    );

    if (!topmostVisiblePanel) return;

    const link = this.linkTargets.find(link =>
      link.getAttribute('href') === `#${topmostVisiblePanel.id}`
    );

    if (link) this.#activateLink(link);
  }

  #activateLink(link) {
    this.linkTargets.forEach(link => link.classList.remove('active'));
    link.classList.add('active');
    const tab = new bootstrap.Tab(link);
    tab.show();
  }
}
